/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import { Injectable } from '@angular/core';
import { HttpModule, Http, Headers, Response, RequestOptions } from '@angular/http';
import { OAuthService } from './../oauth/oauth.service';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../environments/environment';
import { Handler } from './../handler';

@Injectable()
export class HeaderBannerService {
    private baseUrl;
    private endpoint = 'home/header-banner';

    constructor(
        private http: Http,
        private oauthService: OAuthService,
        private handler: Handler,
    ) {
        this.baseUrl =environment.apiEndpoint;
    }

    public getCoupon(): Observable<any> {
        return this.oauthService.getAccessToken()
            .flatMap((data) => (this.aux(data)))
            .catch(this.handler.render);
    }

    public aux(accessToken: String): Observable<any> {
        let objHeaders = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.rest.v1+json',
            'Authorization': `Bearer ${accessToken}`
        });
        let options = new RequestOptions({
            headers: objHeaders
        });
        return this.http
            .get(this.baseUrl + this.endpoint, options)
            .map((response: Response) => (response.json().message));
    }
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/services/Home/header-banner.service.ts